import React, { useEffect, useState } from "react";
import "../../profile.css";

import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
} from "lucide-react";

import { useNavigate } from "react-router-dom";

import service from "../../services/service";
import endpoints from "../../services/endpoints";

const Faqs = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(null);
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* =========================
      GET FAQS
  ========================= */

  const getFaqs = async () => {
    try {
      setLoading(true);

      const response = await service.get(
        endpoints.cms.faq,
      );

      setFaqData(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFaqs();
  }, []);

  return (
    <div className="info-page">
      <div className="info-page-top">
        <ArrowLeft
          className="back-btn"
          onClick={() => navigate("/contact-info")}
        />

        <h2>FAQ’s</h2>
      </div>

      {loading ? (
        <p className="favourites-loading">
          Loading FAQs...
        </p>
      ) : faqData?.length > 0 ? (
        <div className="faq-container">
          {faqData.map((faq, index) => (
            <div className="faq-item" key={faq?.id}>
              <div
                className="faq-question"
                onClick={() =>
                  setOpen(open === index ? null : index)
                }
              >
                <span>{faq?.question}</span>

                {open === index ? (
                  <ChevronUp size={18} />
                ) : (
                  <ChevronDown size={18} />
                )}
              </div>

              {open === index && (
                <div className="faq-answer">
                  {faq?.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="favourites-loading">
          No FAQs found
        </p>
      )}
    </div>
  );
};

export default Faqs;